/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import { OriginType, PitRoadData, SanctioningBodyEnum } from 'models/viewModels';
import { StreamRequestType } from './RSocketObject';
import { RSocketStreamBaseService } from './RSocketStreamBaseService';

class PitRoadDataService extends RSocketStreamBaseService<PitRoadData[], PitRoadData> {
  protected async getStreamHistoryRequest(): Promise<PitRoadData[]> {
    return axiosConfig(ApiRequestType.StreamMetricsApi)
      .post('/rest/backfill/pitSummary', this.request)
      .then((response) => {
        return response.data as PitRoadData[];
      })
      .catch(() => {
        return [];
      });
  }

  protected onDataCallback = (response: PitRoadData) => {
    if (this.listeners.size > 0) {
      const currentPitData = [...this.localCache];
      const pitMessage = currentPitData.find(
        (item) => item.vehicleNumber === response.vehicleNumber && item.lap === response.lap
      );

      // if entry already exists
      if (pitMessage) {
        const newPitMessage: PitRoadData = {
          ...response,
          pitPositionMetadata:
            response.pitPositionMetadata.pitInLap === 0 ? pitMessage.pitPositionMetadata : response.pitPositionMetadata,
          greenInList: response.greenInList.length > 0 ? [...response.greenInList] : pitMessage.greenInList,
          greenOutList: response.greenOutList.length > 0 ? [...response.greenOutList] : pitMessage.greenOutList,
        };
        const newPitData = [...currentPitData].map((item) => {
          if (item.lap === newPitMessage.lap && item.vehicleNumber === newPitMessage.vehicleNumber) {
            return newPitMessage;
          }
          return item;
        });
        this.localCache = newPitData;
      } else {
        const newPitData = [...currentPitData, response];
        this.localCache = newPitData;
      }
    }
  };

  async start() {
    this.delay = 1000;
    super.start();
  }
}

export const pitRoadDataService: Map<SanctioningBodyEnum, Map<OriginType, PitRoadDataService>> = new Map(
  (Object.values(SanctioningBodyEnum) as SanctioningBodyEnum[])
    .filter((x) => typeof x === 'number')
    .map((sanctioningBody) => [
      sanctioningBody,
      new Map(
        (Object.values(OriginType) as OriginType[])
          .filter((x) => typeof x === 'number')
          .map((source: OriginType) => [
            source,
            new PitRoadDataService({
              route: 'stream.pit',
              connectionType: StreamRequestType.MotorsportsStreamApi,
              originType: source,
              sanctioningBody: sanctioningBody,
            }),
          ])
      ),
    ])
);
